//These enums should be used in preference to explicit routes
export enum ClientRoute {
  SUPPORTED_LANGUAGES = '/sites/:siteId/settings/supportedlanguages',
  FREQ_CAPS_EDIT = `/sites/:siteId/settings/frequencycaps/:frequencyCapId/edit`,
  FREQ_CAPS_CREATE = `/sites/:siteId/settings/frequencycaps/create`,
  FREQ_CAPS_LIST = `/sites/:siteId/settings/frequencycaps`,
  ALLOW_LIST = `/sites/:siteId/settings/allowlist`,
  BLOCK_LIST = `/sites/:siteId/settings/blocklist`,
}
